module.exports = __webpack_public_path__ + "static/media/hero-image.9ef56ac6.png";